import { styled, Typography, TypographyProps } from '@mui/material';

export const CommonPageContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  padding: theme.spacing(2),
  minWidth: 392,
  width: 500,
  backgroundColor: theme.palette.grey[100],
}));

const CommonPageHeaderTypography = styled(Typography)({
  display: 'flex',
  alignItems: 'center',
});

export const CommonPageHeader = (props: TypographyProps) => <CommonPageHeaderTypography variant="h6" {...props} />;

export const CommonPageScrollableContent = styled('div')({
  overflowY: 'auto',
});
